export function checkPythHex(str: string) {
  const regex = /^0x[a-fA-F0-9]{64}$/
  return regex.test(str)
}
